import Stage from '@/domain/entities/flow/Stage';
import Feedback from '@/domain/entities/flow/Feedback';

type MarkerType = 'INFORMATIVE' | 'DECISIVE';

export interface WalkMarker {
  id: string;
  type: MarkerType;
  name: string;
  description: string | null;
  image_url: string | null;
  latitude: number;
  longitude: number;
  label: string | null;
  next_stage_button_text: string | null;
}

export interface WalkStage {
  id: string;
  name: string;
  description: string | null;
  image_url: string;
  latitude: number;
  longitude: number;
  sphere_correction_pan: number;
  sphere_correction_tilt: number;
  start_position_x: number;
  start_position_y: number;
  markers: WalkMarker[];
  links: string[];
}

interface Props {
  id: string;
  type: string;
  order: number;
  completedAt: Date | null;
  startedAt?: Date | null;
  timeLimit: number | null;
  title: string;
  feedback: Feedback | null;
  stages: WalkStage[];
}

export default class Game3dWalk extends Stage {
  readonly title: string;
  readonly feedback: Feedback | null;
  readonly stages: WalkStage[];

  constructor({
    id,
    type,
    order,
    completedAt,
    startedAt,
    timeLimit,
    title,
    feedback,
    stages,
  }: Props) {
    super({ id, type, order, completedAt, startedAt, timeLimit });

    this.title = title;
    this.feedback = feedback;
    this.stages = stages;
  }
}
